export enum AnalyticsEvents {
  PageTracking = 'page_view',

  LiveVideoTabOpen = 'live_video_tab_open',
  LiveVideoTabClosed = 'live_video_tab_closed',
  LiveVideoTabFullscreen = 'live_video_tab_fullscreen',

  LiveChatMessageSent = 'live_chat_message_sent',
}
